"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _constants = require("./constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Spinner = function Spinner(_ref) {
  var size = _ref.size,
      white = _ref.white,
      className = _ref.className,
      props = _objectWithoutProperties(_ref, ["size", "white", "className"]);

  var classNames = (0, _classnames.default)('spinner', className, {
    '-medium': size === _constants.spinnerSizes.MEDIUM,
    '-large': size === _constants.spinnerSizes.LARGE,
    '-white': white
  });
  return _react.default.createElement("svg", _extends({
    className: classNames,
    viewBox: "25 25 50 50",
    role: "presentation",
    "aria-hidden": "true"
  }, props), _react.default.createElement("circle", {
    className: "spinner__circle",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  }), _react.default.createElement("circle", {
    className: "spinner__circle -spin",
    cx: "50",
    cy: "50",
    r: "20",
    fill: "none"
  }));
};

Spinner.displayName = 'Spinner';
Spinner.propTypes = {
  /** The class name to add to the component. */
  className: _propTypes.default.string,

  /** The size of the Spinner */
  size: _propTypes.default.oneOf(Object.values(_constants.spinnerSizes)),

  /** Set Spinner colour to white */
  white: _propTypes.default.bool
};
var _default = Spinner;
exports.default = _default;